
/**
 * Not used currently
 */
export async function load(id: string) {
  return await import(id);
}
